export interface ThemeConfig {
    id: string;
    name: string;
    nameVi: string;
    category: string;
    colors: {
        primary: string;
        secondary: string;
        accent: string;
        background: string;
        surface: string;
        text: string;
        textMuted: string;
    };
    gradient: {
        from: string;
        via: string;
        to: string;
    };
    artworkGradient: string;
}

export const themes: ThemeConfig[] = [
    {
        id: 'traditional',
        name: 'Traditional',
        nameVi: 'Truyền thống',
        category: 'classic',
        colors: {
            primary: '#DC2626',
            secondary: '#FCD34D',
            accent: '#B91C1C',
            background: '#1F1F1F',
            surface: '#2D2D2D',
            text: '#FFFFFF',
            textMuted: 'rgba(255, 255, 255, 0.7)',
        },
        gradient: {
            from: '#DC2626',
            via: '#B91C1C',
            to: '#7F1D1D',
        },
        artworkGradient: 'from-red-600 via-red-700 to-amber-600',
    },
    {
        id: 'modern',
        name: 'Modern',
        nameVi: 'Hiện đại',
        category: 'minimal',
        colors: {
            primary: '#3B82F6',
            secondary: '#14B8A6',
            accent: '#0EA5E9',
            background: '#0F172A',
            surface: '#1E293B',
            text: '#FFFFFF',
            textMuted: 'rgba(255, 255, 255, 0.7)',
        },
        gradient: {
            from: '#3B82F6',
            via: '#0EA5E9',
            to: '#14B8A6',
        },
        artworkGradient: 'from-blue-500 via-cyan-500 to-teal-500',
    },
    {
        id: 'nature',
        name: 'Nature',
        nameVi: 'Thiên nhiên',
        category: 'seasonal',
        colors: {
            primary: '#22C55E',
            secondary: '#EAB308',
            accent: '#16A34A',
            background: '#14532D',
            surface: '#166534',
            text: '#FFFFFF',
            textMuted: 'rgba(255, 255, 255, 0.7)',
        },
        gradient: {
            from: '#22C55E',
            via: '#16A34A',
            to: '#EAB308',
        },
        artworkGradient: 'from-green-500 via-emerald-600 to-yellow-500',
    },
];

export const DEFAULT_THEME_ID = 'traditional';

export function getThemeById(id: string): ThemeConfig {
    return themes.find((t) => t.id === id) || themes[0];
}
